// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-traveler-login-travelerLoginCard-module__paddingBottom--Rheas {
    padding-bottom: 32px;
  }
  
.src-js-traveler-login-travelerLoginCard-module__flexColumnCenter--UuDSQ {
    flex-direction: column;
    align-items: center;
  }`, "",{"version":3,"sources":["webpack://./src/js/traveler/login/travelerLoginCard.module.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;EACtB;;AAEF;IACI,sBAAsB;IACtB,mBAAmB;EACrB","sourcesContent":[".paddingBottom {\n    padding-bottom: 32px;\n  }\n  \n.flexColumnCenter {\n    flex-direction: column;\n    align-items: center;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paddingBottom": `src-js-traveler-login-travelerLoginCard-module__paddingBottom--Rheas`,
	"flexColumnCenter": `src-js-traveler-login-travelerLoginCard-module__flexColumnCenter--UuDSQ`
};
export default ___CSS_LOADER_EXPORT___;
